import { kebabCase } from 'lodash-es';

/** Infix between the combobox prefix and each item's identifier in item testIds. */
const COMBOBOX_ITEM_TESTID_INFIX = 'item';

/**
 * The testIdName assigned to each combobox menu item, before HBMenuItem appends its
 * own `--menu-item` suffix. Shared by HBCombobox (the producer) and HBComboboxDriver
 * (the matcher) so the item testId format is defined in exactly one place.
 */
export const buildComboboxItemTestIdName = (
    prefix: string,
    identifier: string
): string => `${prefix}-${COMBOBOX_ITEM_TESTID_INFIX}-${identifier}`;

/**
 * The trailing portion of a rendered menu item's `data-testid`, used by
 * `HBComboboxDriver.getItemByTestIdName` to match an item by its stable identifier
 * via `endsWith`. Mirrors the kebab-casing applied by the testId builder and
 * HBMenuItem's `suffix: 'menu-item'` — keep this in sync if either changes.
 */
export const comboboxItemTestIdSuffix = (identifier: string): string =>
    `-${COMBOBOX_ITEM_TESTID_INFIX}-${kebabCase(identifier)}--menu-item`;
